// extracted by mini-css-extract-plugin
export var container = "_lg-0";
export var dotAnimation = "_lg-2";
export var dotsLoading = "_lg-1";